import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { User, Users2 } from "lucide-react";
import { Link } from "react-router-dom";
import QuickLessonDialog from "@/components/QuickLessonDialog";
import QuickActivityDialog from "@/components/QuickActivityDialog";
import TrainingStats from "@/pages/TrainingStats";
import TechToday from "@/pages/TechToday";
import StaffControl from "@/pages/StaffControl";

function todayISO() { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; }

/**
 * TrainingHub — pagina Allenamento (v2.0 Phase 4).
 * Tab: Oggi (vista tecnico v2) · Statistiche · Staff Control (Direzione Tecnica).
 */
export default function TrainingHub() {
  const { user } = useAuth();
  const [openLesson, setOpenLesson] = useState(false);
  const [openActivity, setOpenActivity] = useState(false);
  const [activeSessionId, setActiveSessionId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const ensureSession = useCallback(async () => {
    try { const { data } = await api.post("/training/ensure-session"); setActiveSessionId(data?.id || null); }
    catch { setActiveSessionId(null); }
  }, []);

  useEffect(() => { ensureSession(); }, [ensureSession]);

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between flex-wrap gap-4">
        <div>
          <h1 className="font-heading text-4xl font-bold tracking-tight">Allenamento</h1>
          <p className="text-zinc-500 mt-1">Cosa mi aspetta oggi · <Link to="/allenamento" className="underline">Pianificazione settimanale →</Link></p>
        </div>
        <div className="flex items-center gap-2">
          <Button data-testid="hub-new-activity" variant="outline" className="h-12 px-5" onClick={() => setOpenActivity(true)}>
            <Users2 className="w-4 h-4 mr-2" /> + Attività
          </Button>
          <Button data-testid="hub-new-lesson" className="h-12 px-5 bg-black hover:bg-zinc-800" onClick={() => setOpenLesson(true)}>
            <User className="w-4 h-4 mr-2" /> + Lezione
          </Button>
        </div>
      </div>

      <Tabs defaultValue="today">
        <TabsList>
          <TabsTrigger value="today" data-testid="tab-today">Oggi</TabsTrigger>
          <TabsTrigger value="stats" data-testid="tab-stats">Statistiche</TabsTrigger>
          <TabsTrigger value="staff" data-testid="tab-staff">Staff Control</TabsTrigger>
        </TabsList>

        <TabsContent value="today" className="pt-6"><TechToday key={`today-${refreshKey}`} /></TabsContent>
        <TabsContent value="stats" className="pt-6"><TrainingStats /></TabsContent>
        <TabsContent value="staff" className="pt-6"><StaffControl key={`staff-${refreshKey}`} /></TabsContent>
      </Tabs>

      <QuickLessonDialog open={openLesson} onOpenChange={setOpenLesson} sessionId={activeSessionId} defaultCoachId={user?.id} onSaved={() => setRefreshKey((k) => k + 1)} />
      <QuickActivityDialog open={openActivity} onOpenChange={setOpenActivity} sessionId={activeSessionId} defaultCoachId={user?.id} onSaved={() => setRefreshKey((k) => k + 1)} />
    </div>
  );
}
